<template>
    <div class="modal video-modal fade in show " :id="modalId" tabindex="-1" role="dialog" :aria-labelledby="modalId" aria-hidden="false" >
            <div class="modal-dialog modal-dialog-centered fadeIn" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                    </div>
                    <div class="modal-body">
                        <div class="video-holder">
                            <video loop preload="auto" controls playsinline>
                                <source src="/video/Orientation_Part_2_Timesheets_and_Payroll.mp4" type="video/mp4">
                            </video>
                        </div>
                    </div>
                </div>
            </div>
        </div>
</template>

<script>

export default {
    name: 'VideoModal',
    props: {
        modalId: String,
    }

}

</script>

<style scoped>

</style>
